/* ------------------------------------------------------------------ *
 * chr-vehicle-recs.js — Canada Hitch Rack
 *
 * Builds the "You may also like" row on a product page out of parts that
 * actually fit the shopper's saved vehicle.
 *
 * Two sources, in order:
 *   1. This product's own category, narrowed by the vehicle tag — the
 *      other Class 3 hitches that fit their truck.
 *   2. The universal accessories collection chosen in the section
 *      settings. Universal stock carries no fitment data, so it can
 *      never come back from a tag-filtered query; it has to be named.
 *
 * Both are fetched through ?view=chr-cards, which returns real
 * card-product markup — the cards arrive styled, with quick-add already
 * wired, rather than being rebuilt here.
 *
 * With no vehicle saved this does nothing at all and Dawn's own
 * related-products section is left to do the job.
 * ------------------------------------------------------------------ */

(function () {
  'use strict';

  var VEHICLE_KEY = 'chr:vehicle';

  function savedVehicle() {
    try {
      var v = JSON.parse(localStorage.getItem(VEHICLE_KEY) || 'null');
      return v && v.tag ? v : null;
    } catch (e) {
      return null;
    }
  }

  function fetchCards(path) {
    return fetch(path, { headers: { Accept: 'text/html' } })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return [].slice.call(doc.querySelectorAll('li.grid__item'));
      })
      .catch(function () {
        return [];
      });
  }

  function init() {
    var root = document.querySelector('[data-chr-recs]');
    if (!root) return;

    var vehicle = savedVehicle();
    if (!vehicle) return; // no vehicle — Dawn's related products stand

    var source = root.getAttribute('data-source');
    var source2 = root.getAttribute('data-source2');
    var current = root.getAttribute('data-current');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
    var universal = root.getAttribute('data-universal');
    var uLimit = parseInt(root.getAttribute('data-universal-limit'), 10);
    if (isNaN(uLimit)) uLimit = 0;

    function fitPath(handle) {
      return '/collections/' + handle + '/' + encodeURIComponent(vehicle.tag) + '?view=chr-cards';
    }
    var uniPath = universal ? '/collections/' + universal + '?view=chr-cards' : null;

    Promise.all([
      fetchCards(fitPath(source)),
      source2 ? fetchCards(fitPath(source2)) : Promise.resolve([]),
      uniPath ? fetchCards(uniPath) : Promise.resolve([])
    ]).then(
      function (results) {
        var seen = {};
        seen[current] = true; // never recommend the page you are already on

        function take(cards, n, badge) {
          var out = [];
          for (var i = 0; i < cards.length && out.length < n; i++) {
            var h = cards[i].getAttribute('data-handle');
            if (!h || seen[h]) continue;
            seen[h] = true;
            if (badge) {
              var tag = document.createElement('span');
              tag.className = 'chr-recs__badge';
              tag.textContent = badge;
              cards[i].insertBefore(tag, cards[i].firstChild);
            }
            out.push(cards[i]);
          }
          return out;
        }

        var fitLabel = 'Fits your ' + (vehicle.label || 'vehicle');
        var fits = take(results[0], limit, fitLabel);
        /* Top up from the broader category only if the narrow one came up
           short — the closest matches stay first. */
        if (fits.length < limit) {
          fits = fits.concat(take(results[1], limit - fits.length, fitLabel));
        }
        var uni = take(results[2], uLimit, 'Fits any vehicle');
        var all = fits.concat(uni);

        if (!all.length) return; // nothing to show — leave Dawn's row alone

        var grid = document.createElement('ul');
        grid.className = 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
        grid.setAttribute('role', 'list');
        all.forEach(function (li) {
          grid.appendChild(li);
        });

        var body = root.querySelector('[data-chr-recs-body]');
        body.appendChild(grid);

        var sub = root.querySelector('[data-chr-recs-sub]');
        if (sub) {
          sub.textContent = fits.length
            ? 'Picked for your ' + (vehicle.label || 'vehicle') + '.'
            : 'Universal parts that fit any vehicle.';
        }

        root.hidden = false;

        /* Dawn's own recommendations know nothing about fitment, so once
           this row exists it would only offer the same slots filled with
           parts for other trucks. Hide it rather than contradict us. */
        var dawn = document.querySelector('.related-products');
        if (dawn) {
          var section = dawn.closest('.shopify-section') || dawn;
          section.hidden = true;
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
